import { CheckCircle2, Sparkles } from "lucide-react";

const DemoAlerts = () => {
  return (
    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-3 border border-emerald-200/50">
      <div className="flex items-start gap-2.5">
        <div className="p-1.5 rounded-lg bg-emerald-100">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-0.5">
            <h3 className="text-xs font-bold text-slate-800">
              ✨ Tout va bien !
            </h3>
          </div>
          <p className="text-[10px] text-slate-600 leading-relaxed">
            Vos plantes sont dans des conditions optimales. Prochain arrosage recommandé dans 2 jours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoAlerts;
